/**
 * Many of these functions are adapted from @tfjs-models/body-pix/src/output_rendering_util.ts
 */

type ImageType = HTMLImageElement | HTMLVideoElement | HTMLCanvasElement;

const offscreenCanvases: { [name: string]: HTMLCanvasElement } = {};

export function ensureOffscreenCanvas(name: string): HTMLCanvasElement {
    if (offscreenCanvases[name] === undefined) {
        offscreenCanvases[name] = document.createElement("canvas");
    }

    return offscreenCanvases[name];
}

export function renderImageDataToOffScreenCanvas(imageData: ImageData, canvasName = "mask") {
    const oCanvas = ensureOffscreenCanvas(canvasName);
    oCanvas.width = imageData.width;
    oCanvas.height = imageData.height;
    oCanvas.getContext("2d")!.putImageData(imageData, 0, 0);
    return oCanvas;
}

export function drawAndBlurImageOnOffScreenCanvas(
    image: ImageType,
    blurAmount: number,
    canvasName = "blurredMask"
): HTMLCanvasElement {
    const canvas = ensureOffscreenCanvas(canvasName);
    if (blurAmount === 0) {
        renderImageToCanvas(image, canvas);
    } else {
        drawAndBlurImageOnCanvas(image, blurAmount, canvas);
    }
    return canvas;
}

function renderImageToCanvas(image: ImageType, canvas: HTMLCanvasElement) {
    const { width, height } = image;
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    ctx!.drawImage(image, 0, 0, width, height);
}

function drawAndBlurImageOnCanvas(image: ImageType, blurAmount: number, canvas: HTMLCanvasElement) {
    const { height, width } = image;
    const ctx = canvas.getContext("2d");
    canvas.width = width;
    canvas.height = height;
    ctx!.clearRect(0, 0, width, height);

    withLocalContext(canvas, (ctx2) => {
        ctx2.filter = `blur(${blurAmount}px)`;
        ctx2.drawImage(image, 0, 0, width, height);
    });
}

export function flipCanvasHorizontal(canvas: HTMLCanvasElement) {
    const ctx = canvas.getContext("2d");
    ctx!.scale(-1, 1);
    ctx!.translate(-canvas.width, 0);
}

export function withLocalContext(canvas: HTMLCanvasElement, callback: (ctx: CanvasRenderingContext2D) => void) {
    const ctx = canvas.getContext("2d");
    if (ctx != null) {
        ctx.save();
        callback(ctx);
        ctx.restore();
    }
}
